import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';

import { Panel, Spinner } from '../components/common/index.jsx';
import { meta } from '../lib/api.js';
import { renderMarkdown } from '../lib/markdown.jsx';
import { useAuthStore } from '../store/authStore.js';

export function GuidelinesPage({ requireAck = false }) {
  const navigate = useNavigate();
  const [doc, setDoc] = useState(null);
  const [busy, setBusy] = useState(false);
  const loadBootstrap = useAuthStore((s) => s.loadBootstrap);

  useEffect(() => {
    meta.guidelines().then(setDoc).catch(() => setDoc({ body_md: '', version: 0 }));
  }, []);

  if (!doc) return <Spinner label="Loading the guidelines…" />;

  const acknowledge = async () => {
    setBusy(true);
    try {
      await meta.ackGuidelines(doc.version);
      await loadBootstrap();
      useAuthStore.setState((s) => ({
        user: { ...s.user, guidelines_ack_version: doc.version },
      }));
      navigate('/');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page wide">
      <div className="page-head">
        <h1>Annotation guidelines</h1>
        <p>
          Version {doc.version}
          {doc.acked ? ' · you have read these' : ''}
        </p>
      </div>

      <Panel>
        <div className="prose">{renderMarkdown(doc.body_md)}</div>
      </Panel>

      <p style={{ marginTop: 'var(--space-4)' }}>
        <Link to="/examples">See worked examples &rarr;</Link>
      </p>


      {(requireAck || !doc.acked) && (
        <div className="row" style={{ marginTop: 'var(--space-5)', justifyContent: 'flex-end' }}>
          <button type="button" className="btn primary lg" onClick={acknowledge} disabled={busy}>
            <Check size={16} /> I have read the guidelines
          </button>
        </div>
      )}
    </div>
  );
}
